module.exports = __webpack_public_path__ + "static/media/cigars-com-dark.8e34f7db.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/cigars-com-dark.png
// module id = 370
// module chunks = 0